<mat-chip-set>
    <mat-chip [matMenuTriggerFor]="listDropDownMenu"
              (menuClosed)="valueChanged()"
              (menuOpened)="onMenuOpened()"
              [disabled]="disabled">
        <span [class.st-status-valid]="required && !value"
              [class.st-status-required]="required && !value">{{displayValue}}
        </span>
    </mat-chip>
</mat-chip-set>
<mat-menu #listDropDownMenu="matMenu"
          class="st-status-menu">
    <form [dir]="dir">
        <mat-form-field subscriptSizing="dynamic"
                        appearance="fill">
            <mat-icon matPrefix>search</mat-icon>
            <input type="text"
                   #searchBox
                   matInput
                   [placeholder]="appService.languageSettings.PSTWebSearchLabel"
                   [formControl]="statusFilter">
        </mat-form-field>
        <mat-selection-list [ngModel]="internalValue"
                            hideSingleSelectionIndicator
                            (selectionChange)="internalValueChanged($event)"
                            [multiple]="false">
            <mat-list-option *ngFor="let item of filteredOptions | async"
                             [value]="item"
                             class="st-status-list-options">
                {{getItemStatusLabel(item)}}
                <mat-icon class="st-status-list-options-icon">check</mat-icon>
            </mat-list-option>
        </mat-selection-list>
    </form>
</mat-menu>